import { alignLeftIcon } from './align-left';
import { adminAreaIcon } from './area-icons/admin-area-icon';
import { cxAdminAreaIcon } from './area-icons/cx-admin-area-icon';
import { districtAdminAreaIcon } from './area-icons/district-admin-area-icon';
import { parentAreaIcon } from './area-icons/parent-area-icon';
import { schoolAdminAreaIcon } from './area-icons/school-admin-area-icon';
import { supportAreaIcon } from './area-icons/support-area-icon';
import { teacherAreaIcon } from './area-icons/teacher-area-icon';
import { arrowChevronDownIcon } from './arrow-chevron-down';
import { arrowChevronLeftIcon } from './arrow-chevron-left';
import { arrowChevronRightIcon } from './arrow-chevron-right';
import { arrowChevronUpIcon } from './arrow-chevron-up';
import { arrowRightIcon } from './arrow-right';
import { audioFastForwardIcon } from './audio-fast-forword';
import { audioHeadphonesIcon } from './audio-headphones';
import { audioNextIcon } from './audio-next';
import { audioPauseIcon } from './audio-pause';
import { audioPlayIcon } from './audio-play';
import { audioPreviousIcon } from './audio-previous';
import { audioRewindIcon } from './audio-rewind';
import { backArrowIcon } from './back-arrow';
import { calendarBlank } from './calendar-blank';
import { calendarGoToTodayIcon } from './calendar-go-to-today-icon';
import { cameraIcon } from './camera';
import { caretDownIcon } from './caret-down';
import { checkCircleIcon } from './check-circle';
import { checkCircleInvertedIcon } from './check-circle-inverted';
import { checkMarkIcon } from './check-mark';
import { checkMarkThickIcon } from './check-mark-thick';
import { checkedBoxIcon } from './checked-box';
import { circleDashedIcon} from './circle-dashed';
import { circleFillIcon } from './circle-fill';
import { classroomIcon } from './classroom';
import { clearIcon } from './clear';
import { cogIcon } from './cog';
import { cogIcon2 } from './cog2';
import { copyIcon } from './copy';
import { customCardIcon } from './custom-card';
import { deleteAllIcon } from './delete-all';
import { downloadIcon } from './download';
import { ellipseIcon } from './ellipse';
import { envelopeIcon } from './envelope';
import { eraserIcon } from './eraser';
import { eraserIcon2 } from './eraser2';
import { exclamationInCircle } from './exclamation-in-circle';
import { exportIcon } from './export';
import { eyeIcon } from './eye';
import { fileIcon } from './file';
import { filesIcon } from './files';
import { fileTransfer } from './fileTransfer';
import { flipIcon } from './flip';
import { gridIcon } from './grid';
import { hamburgerIcon } from './hamburger';
import { importFileIcon } from './import-file';
import { infoCircleIcon } from './info-circle';
import { infoCircleInvertedIcon } from './info-circle-inverted';
import { keyGlowIcon } from './key-glow';
import { keyHorizontal } from './key-horizontal';
import { adminTeacherRoleIcon } from './login-role-icons/admin-teacher-role-icon';
import { parentRoleIcon } from './login-role-icons/parent-role-icon';
import { studentRoleIcon } from './login-role-icons/student-role-icon';
import { logoutIcon } from './logout';
import { magnifyingGlassWithMinusIcon } from './magnifying-glass-with-minus';
import { magnifyingGlassWithPlusIcon } from './magnifying-glass-with-plus';
import { maskIcon } from './mask';
import { maximizeIcon } from './maximize';
import { megaphoneIcon } from './megaphone';
import { minimizeIcon } from './minimize';
import { moveHandleIcon } from './move-handle';
import { navigateToFolder } from './navigateToFolder';
import { neutralIcon } from './neutral';
import { notepadIcon } from './notepad';
import { openBookIcon } from './open-book';
import { openInNewIcon } from './open-in-new';
import { pasteIcon } from './paste';
import { pencilIcon } from './pencil';
import { pencilIcon2 } from './pencil2';
import { pencilDrawIcon } from './pencil_draw';
import { printerIcon } from './printer';
import { qrCodeScanIcon } from './qr-code-scan';
import { qrCodeNewIcon } from './qr_code_new';
import { questionMarkIcon } from './question-mark';
import { resizeHandleIcon } from './resize-handle';
import { smileyFaceIcon } from './smiley-face';
import { speakerIcon } from './speaker';
import { tCrossIcon } from './t_cross';
import { thumbDownFillIcon } from './thumb-down-fill';
import { thumbDownOutlineIcon } from './thumb-down-outline';
import { thumbUpFillIcon } from './thumb-up-fill';
import { thumbUpOutlineIcon } from './thumb-up-outline';
import { thumbtackIcon } from './thumbtack';
import { trashCanIcon } from './trash-can';
import { trashCanIcon2 } from './trash-can2';
import { uncheckedBoxIcon } from './unchecked-box';
import { uploadIcon } from './upload';
import { verticalEllipsesIcon } from './vertical-ellipses';
import { warningCircleIcon } from './warning-circle';
import { wrenchesIcon } from './wrenches';
import { xCrossIcon } from './x_cross';
import { xCrossCircleIcon } from './x_cross_circle';
import { zbLogoIcon } from './zb-logo';

export { alignLeftIcon as AlignLeftIcon };
export { smileyFaceIcon as SmileyFaceIcon };
export { printerIcon as PrinterIcon };
export { thumbtackIcon as ThumbtackIcon };
export { xCrossIcon as XCrossIcon };
export { tCrossIcon as TCrossIcon };
export { flipIcon as FlipIcon };
export { pencilIcon as PencilIcon };
export { pencilIcon2 as PencilIcon2 };
export { ellipseIcon as EllipseIcon };
export { eyeIcon as EyeIcon };
export { customCardIcon as CustomCardIcon };
export { neutralIcon as NeutralIcon };
export { notepadIcon as NotepadIcon };
export { backArrowIcon as BackArrowIcon };
export { cameraIcon as CameraIcon };
export { calendarBlank as CalendarBlank };
export { calendarGoToTodayIcon as CalendarGoToTodayIcon };
export { copyIcon as CopyIcon };
export { pasteIcon as PasteIcon };
export { verticalEllipsesIcon as VerticalEllipsesIcon };
export { checkMarkIcon as CheckMarkIcon };
export { checkMarkThickIcon as CheckMarkThickIcon };
export { trashCanIcon as TrashCanIcon };
export { trashCanIcon2 as TrashCanIcon2 };
export { keyGlowIcon as KeyGlowIcon };
export { arrowRightIcon as ArrowRightIcon };
export { audioNextIcon as AudioNextIcon };
export { audioPreviousIcon as AudioPreviousIcon };
export { audioPlayIcon as AudioPlayIcon };
export { audioPauseIcon as AudioPauseIcon };
export { audioRewindIcon as AudioRewindIcon };
export { audioFastForwardIcon as AudioFastForwardIcon };
export { audioHeadphonesIcon as AudioHeadphonesIcon };
export { cogIcon as CogIcon };
export { cogIcon2 as CogIcon2 };
export { maskIcon as MaskIcon };
export { envelopeIcon as EnvelopeIcon };
export { deleteAllIcon as DeleteAllIcon };
export { xCrossCircleIcon as XCrossCircleIcon };
export { arrowChevronRightIcon as ArrowChevronRightIcon };
export { arrowChevronLeftIcon as ArrowChevronLeftIcon };
export { arrowChevronUpIcon as ArrowChevronUpIcon };
export { arrowChevronDownIcon as ArrowChevronDownIcon };
export { downloadIcon as DownloadIcon };
export { exportIcon as ExportIcon };
export { uploadIcon as UploadIcon };
export { fileIcon as FileIcon };
export { filesIcon as FilesIcon };
export { infoCircleIcon as InfoCircleIcon };
export { infoCircleInvertedIcon as InfoCircleInvertedIcon };
export { checkCircleIcon as CheckCircleIcon };
export { uncheckedBoxIcon as UncheckedBoxIcon };
export { checkedBoxIcon as CheckedBoxIcon };
export { moveHandleIcon as MoveHandleIcon };
export { resizeHandleIcon as ResizeHandleIcon };
export { wrenchesIcon as WrenchesIcon };
export { parentRoleIcon as ParentRoleIcon };
export { speakerIcon as SpeakerIcon };
export { studentRoleIcon as StudentRoleIcon };
export { adminTeacherRoleIcon as AdminTeacherRoleIcon };
export { adminAreaIcon as AdminAreaIcon };
export { cxAdminAreaIcon as CxAdminAreaIcon };
export { districtAdminAreaIcon as DistrictAdminAreaIcon };
export { schoolAdminAreaIcon as SchoolAdminAreaIcon };
export { supportAreaIcon as SupportAreaIcon };
export { teacherAreaIcon as TeacherAreaIcon };
export { parentAreaIcon as ParentAreaIcon };
export { exclamationInCircle as ExclamationInCircle };
export { checkCircleInvertedIcon as CheckCircleInverted };
export { keyHorizontal as KeyHorizontal };
export { importFileIcon as ImportFileIcon };
export { qrCodeScanIcon as QrCodeScanIcon };
export { qrCodeNewIcon as QrCodeNewIcon };
export { hamburgerIcon as HamburgerIcon };
export { caretDownIcon as CaretDownIcon };
export { questionMarkIcon as QuestionMarkIcon };
export { zbLogoIcon as ZbLogoIcon };
export { classroomIcon as ClassroomIcon };
export { openBookIcon as OpenBookIcon };
export { logoutIcon as LogoutIcon };
export { clearIcon as ClearIcon };
export { navigateToFolder as NavigateToFolder };
export { fileTransfer as FileTransfer };
export { magnifyingGlassWithMinusIcon as MagnifyingGlassWithMinusIcon };
export { magnifyingGlassWithPlusIcon as MagnifyingGlassWithPlusIcon };
export { eraserIcon as EraserIcon };
export { eraserIcon2 as EraserIcon2 };
export { pencilDrawIcon as PencilDrawIcon };
export { gridIcon as GridIcon };
export { warningCircleIcon as WarningCircleIcon };
export { megaphoneIcon as MegaphoneIcon };
export { maximizeIcon as MaximizeIcon };
export { minimizeIcon as MinimizeIcon };
export { thumbUpFillIcon as ThumbUpFillIcon };
export { thumbUpOutlineIcon as ThumbUpOutlineIcon };
export { thumbDownFillIcon as ThumbDownFillIcon };
export { thumbDownOutlineIcon as ThumbDownOutlineIcon };
export { circleFillIcon as CircleFillIcon };
export { circleDashedIcon as CircleDashedIcon };
export { openInNewIcon as OpenInNewIcon };
